<template>
  <div class="main">
    <headerNav leftNav=" " @leftClick="back"  :title="'子任务详情'"
      @rightClick="onClickDelete" :rightNav="'删除'" :rightIcon="'delete-icon'" :showRightContent="upActiveTab == '3'?false:true">
    </headerNav>
    <main>
      <div class="content">
        <van-cell-group class="cell-group-top cell-group-height">
          <template v-for="(item,index) in typeList.table">
            <van-cell :class="item.class"  v-if="!Array.isArray(item.value)" :title="item.label" title-class="cell-group-title" value-class="cell-group-right">
              <template #right-icon>
                <span v-if="item.unit" class="unit">{{ item.unit }}</span>
                <span v-if="item.click=='subTask'" class="unit"><van-icon name="arrow" /></span>
              </template>
              <template #default>
                <div>
                  <span v-if="upActiveTab == '3'&&item.finishStatus" class="finishStatus" :class="subTaskInfo['finishStatus']?'completed':'incomplete'">{{subTaskInfo['finishStatus'] ? "已完成":"未完成"}}</span>
                  <span>{{ (item.suffix?(item.value+item.suffix):item.value) }}</span>
                </div>
              </template>
            </van-cell>
            <van-cell :class="item.class" v-if="Array.isArray(item.value)" :title="item.label+'('+item.value.length+')'" title-class="cell-group-title" value-class="cell-group-right">
              <template #default>
                <div class="file-content">
                  <img class="img" v-for="(item1,index1) in item.value" :key="index1" :src="item1.fileUrl" @click="imagePreview(item1.fileUrl)">
                </div>
              </template>
            </van-cell>
          </template>
        </van-cell-group>
      </div>
    </main>

    <!-- 删除弹窗 -->
    <van-dialog v-model="dialog" :closeOnClickOverlay="true" confirmButtonColor="#3975C6" show-cancel-button
      @cancel="dialogClose" @confirm="dialogConfirm">
      <div class="dialog-main">
        <div class="dialog-main-reject">
          您确认“ <span>删除</span> ” 该任务吗？
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import api from "@/api/task-management/human-resources.js";
import { subTaskDetailModelFn } from "./data.js"
import { Toast,ImagePreview } from "vant";
import moment from "moment";

export default {
  data () {
    return {
      upActiveTab:"",// 上级页面的Tab active
      routeQueryInfo:{},// 路由携带信息 row
      typeList:{},// 模块类型数据
      subTaskInfo:{}, // 子任务数据
      isModify:false, //是否修改
      dialog: false, // 删除弹窗
    }
  },
  async created() {
    this.upActiveTab = this.$route.query.upActiveTab
    this.routeQueryInfo = JSON.parse(this.$route.query.item)
  },
  mounted() {
    this.getData()
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    // 获取详情
    getData () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let params = {
        "id": this.routeQueryInfo.id,
      }
      api.getSubTaskDetail(params).then((res)=>{
        if (res.code == 200) {
          Toast.clear()
          this.subTaskInfo = res.data
          this.typeList = subTaskDetailModelFn(this.subTaskInfo.termId)
          this.typeList.table.forEach((item,index) => {
            item.value = this.subTaskInfo[item.prop]?this.subTaskInfo[item.prop]:''
            if(item.prop == "finishRate"){
              item.value = item.value ? parseFloat(item.value).toFixed(2) : '-'
            }else{
              item.value = item.value ? item.value : '-'
            }
            this.subTaskInfo[item.prop] = item.value
          });
          this.$forceUpdate()
        }else{
          Toast.fail(res.msg)
        }
      })
    },
    // 打开删除弹窗
    onClickDelete(){
      this.dialog = true
    },
    // 删除弹窗关闭
    dialogClose () {},
    // 删除弹窗确认
    dialogConfirm(){
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      let params = {
        "id":this.routeQueryInfo.id,
      }
      api.removeSubTask(params).then((res)=>{
        if (res.code == 200) {
          Toast.success('操作成功');
          let _this = this;
          setTimeout(()=>{
            _this.back()
          },1000)
        }else{
          Toast.fail(res.msg)
        }
      })
    },
    // 预览图片
    imagePreview(url){
      ImagePreview({
        images: [url],
        closeable: true,
        showIndex: false
      });
    },

  }
}
</script>

<style lang="scss" scoped>
.main::v-deep {
  background: #F5F5F5;
  height: 100vh;

  .content {
    height: calc(100vh - 51px);
    overflow: auto;

    .cell-group-top {
      border-radius: 0px 0px 8px 8px;
      overflow: auto;
    }

    .cell-group-height{
      max-height: calc(100% - 90px);
    }

    .cell-group-center {
      border-radius: 8px;
      overflow: hidden;
      margin: 8px 0;

      .accessory {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .accessory-img {
          width: 20px;
          height: 24px;
          margin-right: 4px;
        }

        .accessory-text {
          font-size: 18px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #0084F4;
        }
      }
    }

    .cell-group-bottom {
      border-radius: 8px;
      overflow: hidden;

      .mistakes {
        span {
          color: #ED4040;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
        }
      }

      .postpone {
        span {
          color: #FF8C21;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
        }
      }

      .final-score {
        span {
          color: #0084F4;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
        }
      }
    }

    .cell-group-title {
      font-size: 16px;
      font-family: PingFang TC, PingFang TC;
      font-weight: 400;
      color: #999999;
      text-align: left;
    }

    .cell-group-right,.van-field__control {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #000000;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .market-icon{
        display: inline-block;
        line-height: 25px;
        padding: 0 4px;
        background: rgba(242,109,12,0.1);
        border-radius: 3px 3px 3px 3px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #F26D0C;
        margin-right: 8px;
      }
      .finishStatus{
        display: inline-block;
        width: 52px;
        line-height: 22px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        margin-right: 8px;
        border-radius: 4px;
      }
      .completed{
        background: #17CA5E;
      }
      .incomplete{
        background: #FF6259;
      }
    }
    .van-field__label {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #1d2129;
    }
    .van-field__value {
      font-size: 16px;
    }

    .footer{
      width: 100%;
      background: #fff;
      padding: 11px 18px 30px;
      box-sizing: border-box;
      box-shadow: 0px -1px 8px 0px rgba(0,0,0,0.04);
      position: absolute;
      bottom: 0;
      .footer-btn{
        line-height: 44px;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        background: #3975C6;
        border-radius: 4px 4px 4px 4px;
      }
      .untouched{
        opacity: .5;
      }
    }
  }

  .van-field__control{
    text-align: right;
  }
  
  .van-field__button{
    color: #000 !important;
  }
  .unit{
    color: #000 !important;
    padding-left: 8px !important;
  }
  .van-cell__value{
    overflow: visible;
  }
  .file-content{
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    width: 255px;

    .img{
      width: 72px;
      height: 72px;
      margin:0 0 11px 11px;
      border-radius: 4px;
      border: 1px solid rgba(217,217,217,0.4);
    }
  }
  .interval{
    border-top: 10px solid #F5F5F5;
  }

  .dialog-main {
    padding: 16px;
    border-bottom: 1px solid #EEEEEE;
    .dialog-main-reject {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      color: #000000;
      margin: 20px 0px;

      span {
        color: #ED4040;
      }
    }
  }
  
}
</style>